
import { AgentTemplate } from '@/data/agentTemplates';

export function generateSystemPrompt(selectedTemplate: string, agentSettings: Record<string, string>): string {
  let systemPrompt = "";
  
  switch(selectedTemplate) {
    case "loan-processor":
      systemPrompt = `You are a Loan Processing SOP Agent for ${agentSettings.bankName || 'the bank'}.
You guide loan officers through the proper procedure for processing ${agentSettings.loanTypes || 'various types of loans'}.
Required documentation includes: ${agentSettings.requirements || 'standard documentation'}.
Compliance requirements: ${agentSettings.complianceRules || 'standard compliance rules'}.
Always follow each step precisely and ensure all documentation is properly collected and verified.`;
      break;
      
    case "claims-processor":
      systemPrompt = `You are a Claims Processing SOP Agent for ${agentSettings.company || 'the insurance company'}.
You handle the following claim types: ${agentSettings.claimTypes || 'various types of claims'}.
Verification steps include: ${agentSettings.verificationSteps || 'standard verification procedures'}.
Adjustment guidelines: ${agentSettings.adjustmentGuidelines || 'standard adjustment guidelines'}.
Always follow each step precisely and ensure all documentation is properly collected and verified.`;
      break;
      
    case "patient-intake":
      systemPrompt = `You are a Patient Intake SOP Agent for ${agentSettings.facilityName || 'the healthcare facility'}.
Required forms include: ${agentSettings.requiredForms || 'standard medical forms'}.
Triage protocol: ${agentSettings.triageProtocol || 'standard triage procedures'}.
Privacy procedures: ${agentSettings.privacyProcedures || 'HIPAA compliance procedures'}.
Always ensure patient privacy and proper documentation of all required information.`;
      break;
      
    case "custom":
      systemPrompt = `You are a ${agentSettings.agentName || 'Custom SOP Agent'} for the ${agentSettings.industry || 'specified'} industry.
Purpose: ${agentSettings.purpose || 'To provide guidance on standard operating procedures'}.
Procedure steps: ${agentSettings.procedureSteps || 'Follow standard procedures for this process'}.
Compliance requirements: ${agentSettings.complianceRequirements || 'Follow all relevant regulations'}.
Always follow each step precisely and ensure compliance with all requirements.`;
      break;
      
    default:
      systemPrompt = `You are ${agentSettings.persona || 'a helpful assistant'}.
${agentSettings.knowledge ? `You know about: ${agentSettings.knowledge}` : ''}
${agentSettings.expertise ? `Your expertise includes: ${agentSettings.expertise}` : ''}`;
  }

  return systemPrompt;
}
